import AxL from "../js/axl.js";
export default class DraggableModal {
  constructor(scope, json) {
    this.json = json;
    this.scope = scope;
    this.asset_id = json.id;
    this.isTouch = "ontouchstart" in document.documentElement;
    this.modal = document.createElement("div");
    this.modal.className = "draggableModal";
    document.body.appendChild(this.modal);
    this.wrapper = document.createElement("div");
    this.wrapper.className = "wrapper";
    this.modal.appendChild(this.wrapper);
    this.setup();
    this.makeItDraggable();
  }
  setup() {
    const url =
      this.json.parsed.thumbnail.replace("http://", "https://") + "=w300";
    this.img = new Image();
    this.img.onload = this.onloaded.bind(this);
    this.img.src = url;
    //text
    const title = document.createElement("span");
    title.className = "artwork_title";
    title.textContent = this.json.parsed.title;
    const author = title.cloneNode(false);
    author.className = "artwork_author";
    author.textContent = this.json.parsed.creator;
    const collection = title.cloneNode(false);
    collection.className = "artwork_collection";
    collection.textContent = this.json.parsed.collection;
    this.learnMore = document.querySelector(".learnMoreButton").cloneNode(true);
    if (this.learnMore.classList.contains("hide"))
      this.learnMore.classList.remove("hide");

    const p = document.createElement("p");
    this.wrapper.appendChild(this.img);
    p.appendChild(title);
    p.appendChild(author);
    p.appendChild(collection);
    p.appendChild(this.learnMore);
    this.wrapper.appendChild(p);
  }
  onloaded(e) {
    const offx = 20; //window.innerWidth / 2 - this.modal.getBoundingClientRect().width / 2;
    const offy = !e
      ? window.innerHeight - this.modal.getBoundingClientRect().height
      : window.innerHeight - (this.modal.getBoundingClientRect().height + 85);
    this.center = { x: offx, y: offy };
    this.modal.setAttribute("data-left", offx);
    this.modal.setAttribute("data-top", offy);
    this.modal.style.transform =
      "translate(" +
      this.modal.getAttribute("data-left") +
      "px," +
      this.modal.getAttribute("data-top") +
      "px)";
  }
  open() {
    this.onloaded(null);
    this.reCenter();
    if (!this.modal.classList.contains("show"))
      this.modal.classList.add("show");
    this.scope.help.textContent = "image_not_supported";
    if (!this.scope.isMobile)
      this.scope.toolTips.tooltips[this.scope.help.index].tooltip.textContent =
        this.scope.translator
          ? this.scope.translator.get("hide_preview")
          : "Hide preview";
    // --> ANALYTICS
    if (this.scope.axl) {
      this.scope.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "preview_asset",
        label: "preview_toggle_button_on / " + this.asset_id,
        value: 0,
        nonInteraction: false,
      });
    }
  }
  close() {
    if (this.modal.classList.contains("show"))
      this.modal.classList.remove("show");
    this.scope.help.textContent = "image";
    if (!this.scope.isMobile)
      this.scope.toolTips.tooltips[this.scope.help.index].tooltip.textContent =
        this.scope.translator
          ? this.scope.translator.get("preview")
          : "Preview";
    if (this.scope.axl) {
      this.scope.axl.sendMessage(AxL.ChildToHost.TRACK, {
        action: "preview_asset",
        label: "preview_toggle_button_off / " + this.asset_id,
        value: 0,
        nonInteraction: false,
      });
    }
  }
  makeItDraggable() {
    this.offsetX = 0;
    this.offsetY = 0;
    this.x = 0;
    this.y = 0;
    this.downHandler = this.onstart.bind(this);
    this.dragHandler = this.ondrag.bind(this);
    this.upHandler = this.onrelease.bind(this);
    this.closeHandler = this.onclose.bind(this);
    this.finishHandler = this.onfinish.bind(this);
    this.learnMoreHandler = this.onLearnMore.bind(this);
    this.learnMore.addEventListener("click", this.learnMoreHandler);
    if (this.isTouch) {
      this.modal.addEventListener("touchstart", this.downHandler);
    } else {
      this.modal.addEventListener("mousedown", this.downHandler);
      this.modal.addEventListener("mouseleave", this.upHandler);
    }
  }

  onstart(e) {
    e = e || window.event;
    e.preventDefault();
    // safety
    if (this.modal.classList.contains("withTransition"))
      this.modal.classList.remove("withTransition");
    const clientX = e.clientX || e.touches[0].clientX;
    const clientY = e.clientY || e.touches[0].clientY;
    this.x = clientX;
    this.y = clientY;

    if (this.isTouch) {
      this.modal.addEventListener("touchmove", this.dragHandler);
      this.modal.addEventListener("touchend", this.upHandler);
    } else {
      this.modal.addEventListener("mousemove", this.dragHandler);
      this.modal.addEventListener("mouseup", this.upHandler);
    }
  }
  ondrag(e) {
    e = e || window.event;
    e.preventDefault();
    const clientX = this.isTouch ? e.touches[0].clientX : e.clientX;
    const clientY = this.isTouch ? e.touches[0].clientY : e.clientY;
    this.offsetX = this.x - clientX;
    this.offsetY = this.y - clientY;
    this.x = clientX;
    this.y = clientY;
    const newPosx = this.modal.getAttribute("data-left") - this.offsetX;
    const newPosy = this.modal.getAttribute("data-top") - this.offsetY;
    this.modal.style.transform =
      "translate(" + newPosx + "px," + newPosy + "px)";
    this.modal.setAttribute("data-left", newPosx);
    this.modal.setAttribute("data-top", newPosy);
  }
  onrelease(e) {
    if (this.isTouch) {
      this.modal.removeEventListener("touchmove", this.dragHandler);
      this.modal.removeEventListener("touchend", this.upHandler);
    } else {
      this.modal.removeEventListener("mousemove", this.dragHandler);
      this.modal.removeEventListener("mouseup", this.upHandler);
    }
    // CHECK IF OUTSIDE OF BOUNDS ....
    const position = this.modal.getBoundingClientRect();
    let changePos = false;
    const replacePosition = { x: position.left, y: position.top };
    if (position.top < 0) {
      changePos = true;
      replacePosition.y = 0;
    }
    if (position.top + position.height > window.innerHeight) {
      changePos = true;
      replacePosition.y = window.innerHeight - position.height;
    }
    if (position.left < 0) {
      changePos = true;
      replacePosition.x = 0;
    }
    if (position.left + position.width > window.innerWidth) {
      changePos = true;
      replacePosition.x = window.innerWidth - position.width;
    }
    if (changePos) {
      console.log("change position");
      this.replace(replacePosition);
    }
  }

  onclose(e) {
    e.stopImmediatePropagation();
    this.close();
  }

  delete() {
    this.modal.removeEventListener("mousedown", this.downHandler);
    this.modal.removeEventListener("mouseleave", this.upHandler);
    this.modal.removeEventListener("mousemove", this.dragHandler);
    this.modal.removeEventListener("mouseup", this.upHandler);
    this.modal.removeEventListener("touchstart", this.downHandler);
    this.modal.removeEventListener("touchmove", this.dragHandler);
    this.modal.removeEventListener("touchend", this.upHandler);
    this.learnMore.removeEventListener("click", this.learnMoreHandler);
    document.body.removeChild(this.modal);
  }
  reCenter() {
    console.log("reCenter");

    const offx = 20; // window.innerWidth / 2 - this.modal.getBoundingClientRect().width / 2;
    const offy =
      window.innerHeight - (this.modal.getBoundingClientRect().height + 85);
    this.center = { x: offx, y: offy };
    //
    this.modal.setAttribute("data-left", this.center.x);
    this.modal.setAttribute("data-top", this.center.y);
    if (!this.modal.classList.contains("withTransition"))
      this.modal.classList.add("withTransition");
    this.modal.style.transform =
      "translate(" + this.center.x + "px," + this.center.y + "px)";
    this.modal.addEventListener("transitionend", this.finishHandler);
  }
  replace(position) {
    this.modal.setAttribute("data-left", position.x);
    this.modal.setAttribute("data-top", position.y);
    if (!this.modal.classList.contains("withTransition"))
      this.modal.classList.add("withTransition");
    this.modal.style.transform =
      "translate(" + position.x + "px," + position.y + "px)";
    this.modal.addEventListener("transitionend", this.finishHandler);
  }
  onfinish(e) {
    if (this.modal.classList.contains("withTransition"))
      this.modal.classList.remove("withTransition");
    this.modal.removeEventListener("transitionend", this.finishHandler);
  }
  onLearnMore(e) {
    if (this.scope.axl) {
      this.scope.axl.sendMessage(
        AxL.ChildToHost.NAVIGATE,
        "asset/" + this.asset_id
      );
      // --> ANALYTICS
      if (this.scope.axl) {
        this.scope.axl.sendMessage(AxL.ChildToHost.TRACK, {
          action: "navigate_to_asset",
          label: "asset_image / " + this.asset_id,
          value: 0,
          nonInteraction: false,
        });
      }
    }
  }
}
